import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';
import Dot from '../Dot';
import Line from '../Line';
import LineTypes from '../Line/LineTypes';

import styles from './Step.Styles';

function Step({ theme, index, noOfSteps, activeIndex, onStepPress, isEditMode }) {
  return (
    <TouchableWithoutFeedback
      onPress={() => _isFunction(onStepPress) && onStepPress(index)}
      key={`step-${index}`}
      testID={FoundationTestKeys.horizontalStepperStepTO}
    >
      <View
        style={styles.dotAndLinesContainerStyle}
        testID={FoundationTestKeys.horizontalStepperStepView}
      >
        <Line
          theme={theme}
          index={index}
          noOfSteps={noOfSteps}
          activeIndex={activeIndex}
          type={LineTypes.LEFT}
          isEditMode={isEditMode}
          testID={FoundationTestKeys.horizontalStepperStepLineLeft}
        />
        <Dot
          theme={theme}
          index={index}
          activeIndex={activeIndex}
          isEditMode={isEditMode}
          testID={FoundationTestKeys.horizontalStepperStepDot}
        />
        <Line
          theme={theme}
          index={index}
          noOfSteps={noOfSteps}
          activeIndex={activeIndex}
          type={LineTypes.RIGHT}
          isEditMode={isEditMode}
          testID={FoundationTestKeys.horizontalStepperStepLineRight}
        />
      </View>
    </TouchableWithoutFeedback>
  );
}

Step.defaultProps = {
  theme: LightThemeColors,
  isEditMode: false,
};

Step.propTypes = {
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  index: PropTypes.number,
  noOfSteps: PropTypes.number,
  activeIndex: PropTypes.number,
  onStepPress: PropTypes.func,
  isEditMode: PropTypes.bool,
};

export default Step;
